export const getters = {
    getTroca: state => state.troca,
    getTrocaVenda: state => state.trocaVenda,
    getProdutosTrocaVenda: state => state.produtosTrocaVenda,
    getModalTrocaVenda: state => state.modalTrocaVenda,
    getProdutosTroca: state => state.produtosTroca,
}

export default {}